import ApplicationErrorFallback from './ApplicationErrorFallback';

export default ApplicationErrorFallback;
